import { useCallback } from 'react'
import { Box } from '@mui/material'
import { useAppActions, useAppProjectSelect, type AppProjectState } from '../AppContext'
import BidProjectView from './bidmanager/BidProjectView'
import BidProjectList from '../comps/BidProjectList'

export default function BidManagerTab() {

  const projectsha = useAppProjectSelect(x => x.currentProject?.projectsha)
  const { setCurrentProject } = useAppActions()

  const handleSelectProject = useCallback((p: any) => {
    setCurrentProject(p)
  }, [setCurrentProject])

  // Stable callbacks so BidProjectView never sees a new prop reference
  // from this component - matters once BidProjectView is memoised.
  const handleBack = useCallback(() => setCurrentProject(null), [setCurrentProject])
  const handleProjectDeleted = useCallback(() => setCurrentProject(null), [setCurrentProject])

  return (
    <Box data-testid="bm_root" sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {!projectsha && (
        <BidProjectList
          onSelectProject={handleSelectProject}
          testIdPrefix="bm"
        />
      )}

      {projectsha && (
        // Key on the project sha so switching bids (e.g. via the global
        // picker from another tab) fully remounts the view rather than
        // leaving stale tab / sub-tab state from the previous project.
        <BidProjectView
          key={projectsha}
          onBack={handleBack}
          onProjectDeleted={handleProjectDeleted}
        />
      )}
    </Box>
  )
}
